<div class="fc-ag-loading-mask">
    <div class="fc-ag-loading-mask-content">
        <div class="fc-ag-loading-mask-icon"></div>
    </div>
    <div class="fc-ag-loading-mask-backdrop"></div>
</div>
